/* eslint-disable jsx-a11y/anchor-is-valid */
import Pagination from "../Pagination/Pagination";
import LoaderHelper from "../LoaderHelper/LoaderHelper";
import usePendingCheckout from "./usePendingCheckout";
import secondaryComponents from "..";
import primaryComponents from "../../primaryComponents";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";

const PendingCheckoutSessions = ({ closeWidget = () => {} }) => {
  const {
    selectedItem,
    instance,
    isFetchingSessions,
    pendingSessions,
    metaDetails,
    showCancelPrompt,
    search,
    filterBySearch,
    cancelCheckout,
    gotoPage,
    setShowCancelPrompt,
    filterByKey,
  } = usePendingCheckout({
    closeWidget,
  });

  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <div className={globalStyles.rowNavigations}>
        <a
          className={`${globalStyles.rowNavigations__item} ${
            search.get("status") === "PENDING_CHECKOUT"
              ? globalStyles.active
              : ""
          }`}
          onClick={() => filterByKey("status", "PENDING_CHECKOUT")}
        >
          Pending Checkouts
        </a>

        <a
          className={`${globalStyles.rowNavigations__item} ${
            search.get("status") === "PAYMENT_REQUIRED"
              ? globalStyles.active
              : ""
          }`}
          onClick={() => filterByKey("status", "PAYMENT_REQUIRED")}
        >
          Oueued POS Payment
        </a>
      </div>
      <section className={`${globalStyles.cardWithBorder} overflow-hidden p-0`}>
        <div className={globalStyles.tableHeader}>
          <primaryComponents.SearchField
            classNames={globalStyles.searchField}
            placeholder={"Search order by customer name"}
            trigger={(value) => filterBySearch(value)}
            value={search.get("query") || ""}
            triggerOnInput={true}
            showsearchBtn={true}
          />
        </div>

        <LoaderHelper isLoading={isFetchingSessions} classNames={"my-5"}>
          <secondaryComponents.TableHelper
            getTableBodyProps={getTableBodyProps}
            getTableProps={getTableProps}
            headerGroups={headerGroups}
            rows={rows}
            prepareRow={prepareRow}
            handleScroll={true}
            hasAction={true}
          >
            <h4 className="my-5 text-center">No Data Available</h4>
          </secondaryComponents.TableHelper>
        </LoaderHelper>

        {pendingSessions?.length > 0 && (
          <div className="mt-auto">
            <Pagination
              totalPageNumber={metaDetails?.last_page}
              handlePageClick={(value) => gotoPage(value?.selected + 1)}
              currentPage={metaDetails?.current_page}
            />
          </div>
        )}
      </section>

      <secondaryComponents.Modal
        isActive={showCancelPrompt}
        closeModal={() => setShowCancelPrompt(false)}
        width="500px"
      >
        <div className="px-3 py-3">
          <h4 className="mb-3 text-center">Cancel Pending Checkout</h4>
          <div
            style={{
              backgroundColor: "#F3F1FC",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              borderRadius: "8px",
            }}
          >
            <p className="dark--text">
              Are you sure you want to remove this pending checkout session with
              the following items:{" "}
              <span className="purple--text">{selectedItem?.items}</span>
            </p>
          </div>
          <div
            className="d-flex justify-content-between mt-4"
            style={{ gap: "20px" }}
          >
            <primaryComponents.Button
              classNames="btn btn--outline cover"
              onClick={() => setShowCancelPrompt(false)}
            >
              No, Cancel
            </primaryComponents.Button>
            <primaryComponents.Button
              classNames="btn btn--primary cover"
              onClick={() => {
                cancelCheckout(selectedItem?.id);
                setShowCancelPrompt(false);
              }}
            >
              Yes, Proceed
            </primaryComponents.Button>
          </div>
        </div>
      </secondaryComponents.Modal>
    </>
  );
};

export default PendingCheckoutSessions;
